import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-section-heading',
  templateUrl: './section-heading.component.html',
  styleUrls: ['./section-heading.component.scss']
})
export class SectionHeadingComponent implements OnInit {

  @Input() label: string = "";
  @Input() light: boolean = false;
  @Input() noMargin: boolean = false;
  @Input() small: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  getFirstLetter(){
    return this.label[0];
  }

  getExceptFirstLetter(){
    return this.label.slice(1,this.label.length)
  }


}
